<template>
  <Layout>
    <div class="banner-page">
      <img src="img/covid-banner.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>Pendaftaran Lembaga</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section covid-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-8">
            <img src="/img/cancel.svg" alt="success" />
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../../views/layouts/Index.vue';

import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
ol {
  li {
    margin-bottom: 5px;
  }
}
ol.nonumber {
  list-style-type: none;
  li {
    margin-bottom: 0px !important;
  }
}
</style>
